import React from 'react';
import { withTheme } from 'styled-components';
export var BiotecnologiaIcon = function BiotecnologiaIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "166px",
    height: "267px",
    viewBox: "0 0 166 267",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Biotecnologi\u0301a"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, React.createElement("g", {
    id: "Biotecnologi\u0301a",
    transform: "translate(-103.000000, 0.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "12"
  }, React.createElement("g", {
    id: "biotecnolog\xEDa",
    transform: "translate(112.000000, 9.000000)"
  }, React.createElement("g", {
    id: "Group"
  }, React.createElement("path", {
    d: "M33.62,117.77 L33.62,134.51 L39.2,140.09 L39.2,229.35 C39.2,241.67 49.19,251.67 61.52,251.67 L72.68,251.67 C85.01,251.67 95,241.68 95,229.35 L95,140.09 L100.58,134.51 L100.58,117.77 L33.62,117.77 Z",
    id: "Path"
  }), React.createElement("path", {
    d: "M37.82,59.95 C48.89,68.42 50.37,89.88 50.37,89.88 C50.37,89.88 33.55,98.35 22.48,89.88 C11.41,81.41 0.16,50.83 0.16,50.83 C0.16,50.83 26.74,51.48 37.82,59.95 Z",
    id: "Path"
  }), React.createElement("path", {
    d: "M75.76,86.94 C62.2,72.04 63.89,45.92 71.74,35.53 C92.76,7.73 121.57,15.86 144.41,0.12 C156.35,22.1 149.91,57.73 130.26,79.61 C117.03,94.34 99.04,92.38 89.94,90.13",
    id: "Path"
  }), React.createElement("path", {
    d: "M67.1,117.77 C71.71,73.21 100.48,51.49 125.44,31.94",
    id: "Path"
  }), React.createElement("line", {
    x1: "39.2",
    y1: "167.98",
    x2: "61.52",
    y2: "167.98",
    id: "Path"
  }), React.createElement("line", {
    x1: "39.2",
    y1: "190.29",
    x2: "61.52",
    y2: "190.29",
    id: "Path"
  }), React.createElement("line", {
    x1: "39.2",
    y1: "212.61",
    x2: "61.52",
    y2: "212.61",
    id: "Path"
  }), React.createElement("line", {
    x1: "39.2",
    y1: "140.08",
    x2: "50.36",
    y2: "140.08",
    id: "Path"
  }), React.createElement("line", {
    x1: "94.99",
    y1: "140.08",
    x2: "67.1",
    y2: "140.08",
    id: "Path"
  }))))));
};
export default withTheme(BiotecnologiaIcon);